import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';

@Component({
  selector: 'app-restore-dialog',
  templateUrl: './restore-dialog.component.html',
  styleUrls: ['./restore-dialog.component.scss'],
  animations: [FadeInAnimation]
})
export class RestoreDialogComponent implements OnInit {

  workflowType: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() { 
    this.workflowType = this.data.workflowType;
  }

}


// WEBPACK FOOTER //
// ./src/app/transfers/restore-dialog.component.ts